import { render } from "./PengadaanDiajukanMenangDetail.vue?vue&type=template&id=a0156f50&scoped=true"
import script from "./PengadaanDiajukanMenangDetail.vue?vue&type=script&lang=js"
export * from "./PengadaanDiajukanMenangDetail.vue?vue&type=script&lang=js"

import "./PengadaanDiajukanMenangDetail.vue?vue&type=style&index=0&id=a0156f50&scoped=true&lang=css"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0156f50"]])

export default __exports__